/** Le classi condivise dalle fasce della prima pagina.
 *
 *  Sta in un modulo senza direttiva perché lo leggono sia Server
 *  Component (le fasce statiche, il piede) sia Client Component (il
 *  registro): una costante esportata da un file "use client" e letta dal
 *  server non è il suo valore (vedi LEAD_DISPACCI nei learnings). */

/** La cornice di ogni fascia: stessa larghezza massima del sito
 *  (`max-w-shell`, 1440) e il margine del riferimento, 32 pixel da `sm`
 *  e 18 sul telefono. A 1280 il contenuto è largo 1216, a 1440 1376,
 *  come nel riferimento. Il guscio del layout sulla prima pagina non
 *  aggiunge rientro (vedi `[data-guscio]` in globals.css). */
export const CORNICE_HOME = "mx-auto w-full max-w-shell px-[18px] sm:px-8";

/** Il contorno del fuoco da tastiera: sabbia, sempre visibile, fuori
 *  dalla scatola. */
import { FUOCO, PULSANTE_PIENO } from "@/components/ui/pulsanti";

export const FUOCO_HOME = FUOCO;

/** L'etichetta mono delle targhe e dei metadati: 11 pixel, maiuscolo. */
export const TARGA = "font-mono text-targa uppercase tracking-[0.06em]";

/** Il pulsante pieno sabbia con il testo scuro. La pelle sta in
 *  components/ui/pulsanti.ts, che la presta a tutto il sito. */
export const PULSANTE_SABBIA =
  "inline-flex items-center justify-between gap-6 px-[18px] py-[13px] " + PULSANTE_PIENO;

/* ── Il disegno del 15/10/2026 (uploads/Prima pagina-html.zip) ──
   Le misure del disegno ricondotte alla scala: 13 → `text-voce`, 12 mono
   → `text-meta` con `tracking-dato` (0,06em, il disegno ne scrive 0,06 e
   0,08), 14 → `text-corpo`, 15 → `text-sommario`. */

/** L'etichetta in Geist (`.oi-k` del disegno): 13, semigrassetto, sonda. */
export const ETICHETTA = "font-sans text-voce font-semibold text-sommesso";

/** La stessa etichetta nel rame del segnale (`.oi-k.acc`). */
export const ETICHETTA_ACCESA = "font-sans text-voce font-semibold text-segnale";

/** La riga dei dati in mono maiuscolo: paese, categoria, ore. */
export const DATI_MONO = "font-mono text-meta uppercase tracking-dato text-sommesso";

/** Il rimando di testo (`.oi-link`): Geist 14 semigrassetto nel mare,
 *  sottolineato solo al passaggio. */
export const RIMANDO =
  "inline-flex items-center gap-1.5 border-b border-transparent font-sans text-corpo font-semibold text-mare no-underline transition-colors hover:border-current " +
  FUOCO;

/** Il pulsante pieno nel mare, col testo carta. */
export const PULSANTE_MARE =
  "inline-flex items-center justify-center gap-2 rounded-[2px] bg-mare px-5 py-[14px] font-sans text-voce font-semibold text-suMare no-underline transition-opacity hover:opacity-90 " +
  FUOCO;

/** Il titolo di una notizia in una scheda o in un elenco: serif, colore
 *  dell'inchiostro, nel mare al passaggio. */
export const TITOLO_LINK = "text-ink no-underline transition-colors hover:text-mare " + FUOCO;
